import { render } from "./AddDriver.vue?vue&type=template&id=080e8106"
import script from "./AddDriver.vue?vue&type=script&lang=js"
export * from "./AddDriver.vue?vue&type=script&lang=js"
script.render = render

export default script